import developerImage from "./assets/images/developer.jpg";

const profile = {
  name: "Kwabena Asante",
  role: "Software Developer",
  location: "Canada",
  photo: developerImage,
  intro:
    "I design cloud-native systems and build AI agents that connect LLMs to real tools, data and APIs.",
};

const about =
  "I am an AWS Certified Developer with several years of experience designing solutions, from desktop applications to large-scale, cloud-native architectures, with a growing focus on AI. I build AI agents that connect LLMs to real tools, data and APIs to automate complex workflows. I bring strong skills in bridging product strategy with technical execution, and I am committed to continuous learning and delivering secure, high-impact solutions.";

const experience = [
  { role: "Software Developer", company: "Geotab", date: "2024 – 2025" },
  { role: "Backend Lead", company: "mPharma", date: "2019 – 2024" },
  { role: "Software Developer", company: "ESW Capital", date: "2018 – 2019" },
  { role: "Consultant", company: "Ampersand Technologies Ltd", date: "2018 – 2019" },
  { role: "Software Developer", company: "Bsystems Limited", date: "2014 – 2018" },
];

const projects = [
  {
    name: "Aktor AI Platform",
    meta: "Personal Project · 2026 – Present",
    description:
      "Gives every customer an AI agent, kept in bounds with isolation, spending limits and approvals.",
    link: "https://aktor.app",
  },
  {
    name: "Zebrok",
    description: "Brokerless task queue for Python based on ZeroMQ.",
    link: "https://github.com/kaypee90/zebrok",
  },
  {
    name: "Awesome Open Standards",
    description: "A curated list of popular open standards.",
    link: "https://github.com/kaypee90/awesome-open-standards",
  },
  {
    name: "Dependabot Wizard",
    description: "Streamlines setting up basic Dependabot configurations for GitHub projects.",
    link: "https://github.com/kaypee90/dependabot-wizard",
  },
  {
    name: "Exp. Query Accelerator",
    description: "Experimental server for caching database fetch queries.",
    link: "https://github.com/kaypee90/exp-query-accelerator",
  },
  {
    name: "DHC Server",
    description:
      "Go application that consumes data captured by the Django Health Check Monitoring library via a REST API.",
    link: "https://github.com/kaypee90/dhc-server",
  },
  {
    name: "Uno Web Framework",
    description: "Experimental web framework that uses a radix tree for routing.",
    link: "https://github.com/kaypee90/unoframework",
  },
];

const skills = ["Python", "TypeScript / JavaScript", "Go", "C#", "SQL", "AWS", "AI Agents / LLMs"];

const education = [
  {
    title: "MBA, Information Systems Management",
    school: "International Business University, Canada",
  },
  {
    title: "BSc Mathematics",
    school: "Kwame Nkrumah University of Science and Technology, Ghana",
  },
];

const certifications = [
  { title: "AWS Certified Developer – Associate", issuer: "Amazon Web Services" },
  { title: "Google Cybersecurity Professional Certificate (v2)", issuer: "Coursera" },
];

const links = [
  { label: "GitHub", url: "https://github.com/kaypee90" },
  { label: "LinkedIn", url: "https://www.linkedin.com/in/kwabena-asante-9b006477" },
];

export {
  profile,
  about,
  experience,
  projects,
  skills,
  education,
  certifications,
  links,
};
